$(document).ready(function() {
  //alert(window.location.href);
  currentUrl = window.location.href;
  parts = currentUrl.split("/");
  firstSegment = parts[3];
  if (firstSegment != "collections") {
    //alert('if block');
    //display block
    collectionPrevLink = getCookie("previousCollectionURL");
    clubImagePathVal = getCookie("clubImagePathVal");
    if (collectionPrevLink != "") {
      //previousCollectionClub = getCookie("previousCollectionClub");
      $("#collection_prev_link").attr("href", collectionPrevLink);
      if (clubImagePathVal != 'undefined') {
        //alert(clubImagePathVal);
        $(".continue-shopping-img").attr("src", clubImagePathVal);
      } else {
        $(".continue-shopping-img-block").css("display","none");
      }
      $(".continue-shopping-top").css("display","block");
    } else {
      $(".continue-shopping-top").css("display","none");
    }
  } else {
  setTimeout(function(){
    clubImagePathVal = $("#club_image_path").attr("src");
    document.cookie = "clubImagePathVal=" + clubImagePathVal + ";path=/";
    //alert(clubImagePathVal);
  }, 2000);
    
    document.cookie = "previousCollectionURL=" + currentUrl + ";path=/";
    $(".continue-shopping-top").css("display","none");
    //alert(currentUrl);
  }

});